// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","container":"onfido-sdk-ui----workflow-engine-Retry-container"};